import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  container: {
    padding: '2rem',
    marginBottom: '5rem',
    fontSize: '16px',
  },
}));
